<template>
  <div class="col5-of-12">
    <label class="is-required">
      Current Password
      <input
        type="password"
        :value="userInfo.oldPassword"
        @blur="handleChange({ key: 'oldPassword', value: $event.target.value })"
      />
      <span v-if="userInfo.oldPasswordError" class="error-text">{{
        userInfo.oldPasswordError
      }}</span>
    </label>
    <hr />
    <label class="is-required">
      New Password
      <input
        type="password"
        :value="userInfo.password"
        @blur="handleChange({ key: 'password', value: $event.target.value })"
      />
      <span v-if="userInfo.passwordError" class="error-text">{{
        userInfo.passwordError
      }}</span>
    </label>
    <label class="is-required">
      Confirm New Password
      <input
        type="password"
        :value="userInfo.confirmPassword"
        @blur="
          handleChange({ key: 'confirmPassword', value: $event.target.value })
        "
      />
      <span v-if="userInfo.confirmPasswordError" class="error-text">{{
        userInfo.confirmPasswordError
      }}</span>
    </label>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: {
    ...mapActions({
      updateUser: 'userAccount/updateUserPassword',
      markDirty: 'userAccount/markDirty',
      markError: 'userAccount/markPasswordError',
    }),
    handleChange(payload) {
      this.markError(payload);
      this.updateUser(payload);
      this.markDirty('password');
    },
  },
  computed: {
    ...mapGetters({
      userInfo: 'userAccount/userInfo',
    }),
  },
};
</script>
